import React from 'react';
import { Alert } from 'antd';
import * as config from '@config';
import { Link } from 'react-router-dom';

function AccommAlert() {
    return (
        <Alert
            message={
                <div>
                    ITO(团队酒店报价、预订)，请填写<Link to={'/dashboard/accommodations/offers'}>查询表格</Link>{' '}
                    ，我们会在48小时给与报价
                </div>
            }
            type="warning"
            showIcon
        />
    );
}

export default AccommAlert;
